import { initializeApp } from "firebase/app";
import { getAuth, initializeAuth, GoogleAuthProvider, browserSessionPersistence, browserPopupRedirectResolver } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { rememberTvTab } from "./lib/tvTab";

// Firebase web config is not secret - access is controlled by the security
// rules in firestore.rules and database.rules.json.
const firebaseConfig = {
  apiKey: "AIzaSyCy-sGVb9duIG8USuhoCSsCmE3Nwp-ysVA",
  // Sign-in runs through our own domain (Firebase serves /__/auth/handler
  // there), so Google's popup says "to continue to partycade.lol". Needs
  // https://partycade.lol/__/auth/handler as a redirect URI on the OAuth
  // client in Google Cloud (APIs & Services → Credentials). The site itself
  // is at www.partycade.lol (partycade.lol redirects there, but not /__/),
  // which counts as the same site, so this keeps working.
  authDomain: "partycade.lol",
  projectId: "partycade-ce024",
  storageBucket: "partycade-ce024.firebasestorage.app",
  messagingSenderId: "61526957808",
  appId: "1:61526957808:web:e1d999c9520d99e2376c35",
  // Realtime Database (europe-west1) powers live rooms.
  databaseURL:
    process.env.REACT_APP_FIREBASE_DATABASE_URL ||
    "https://partycade-ce024-default-rtdb.europe-west1.firebasedatabase.app",
};

export const app = initializeApp(firebaseConfig);

// A TV tab (the big screen in TV mode) is always a guest: it never uses the
// account signed in elsewhere in this browser. It keeps its own sign-in in this
// tab only, and starts signed out (so it never picks up your account). When
// you leave TV mode, a normal tab loads your account again.
rememberTvTab();

// Dev-only: open localhost:3000/?solo in several tabs to get a separate
// player per tab (handy for testing multiplayer on one machine).
let tabOnly = false;
try {
  if (process.env.NODE_ENV === "development" && new URLSearchParams(window.location.search).has("solo")) {
    sessionStorage.setItem("partycade.solo", "1");
  }
  tabOnly = !!sessionStorage.getItem("partycade.solo");
} catch {}

let sessionOnly = false;
function makeAuth() {
  if (tabOnly) {
    try {
      const a = initializeAuth(app, { persistence: browserSessionPersistence, popupRedirectResolver: browserPopupRedirectResolver });
      sessionOnly = true;
      return a;
    } catch {}
  }
  return getAuth(app);
}
export const auth = makeAuth();
// True when this tab's sign-in lives in this tab only (TV and solo tabs).
export const authInSessionOnly = sessionOnly;

// This project's Firestore database is named "default" (not the usual "(default)").
export const db = getFirestore(app, process.env.REACT_APP_FIRESTORE_DATABASE || "default");
export const rtdb = getDatabase(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

